import { IIconProps } from "."

export const ScanIcon = ({ size = 25, opacity = 1 }: IIconProps & { opacity?: number }) => {
	return (
		<svg width={size} height={size} viewBox="0 0 50 50" fill="none" style={{ opacity }}>
			<circle cx="25" cy="25" r="25" fill="#605E5E" />
			<path d="M12.722 12V18.9996H19.7216V12H12.722ZM17.7224 17.0004H14.7224V14.0004H17.7224V17.0004Z" fill="#FFFFFF" />
			<path d="M12.722 28.999V35.9998H19.7216V28.999H12.722ZM17.7224 34.0006H14.7224V31.0006H17.7224V34.0006Z" fill="#FFFFFF" />
			<path d="M29.7224 12V18.9996H36.722V12H29.7224ZM34.7216 17.0004H31.7216V14.0004H34.7216V17.0004Z" fill="#FFFFFF" />
			<path d="M34.7216 21V27H29.7224V28.9992H36.722V21L34.7216 21Z" fill="#FFFFFF" />
			<path d="M29.7224 31.001V36.0002H31.7216V33.0002H34.7216V36.0002H36.722V31.001H29.7224Z" fill="#FFFFFF" />
			<path d="M21.722 12V14.0004H25.7216V18.9996H27.722V12H21.722Z" fill="#FFFFFF" />
			<path
				d="M25.7216 21V25.0008H21.722V31.0008H25.7216V36H27.722V28.9992H23.7224V27H27.722V23.0004H29.7224V25.0008H31.7217V21L25.7216 21Z"
				fill="#FFFFFF"
			/>
			<path d="M21.722 33H23.7224V36H21.722V33Z" fill="#FFFFFF" />
			<path d="M16.7216 25.001H19.7216V27.0002H16.7216V25.001Z" fill="#FFFFFF" />
			<path d="M21.722 16V21.0004H12.722V27.0004H14.7224V23.0008H23.7224V16H21.722Z" fill="#FFFFFF" />
		</svg>
	)
}
